import CssBaseline from "@mui/material/CssBaseline";
import AdminSidebar from "components/admin/AdminSidebar";
import { Box, Container, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import apis from "services";
import PopupTable from "../../components/datagrid/PopupTable";
import { DataGrid } from "@mui/x-data-grid";
import AdminNewSidebar from "components/admin/AdminNewSidebar";
import { Header } from "components";
import { useTranslation } from "react-i18next";
import DeleteModal from "components/modals/DeleteModal";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import { Table, Form, Button, Row, Col } from "react-bootstrap";
import { FaDownload } from "react-icons/fa6";
import { BiPlus } from 'react-icons/bi';
import { useNavigate, useParams } from "react-router-dom"; // Import useNavigate

const Popup = () => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const [tab, setTab] = useState("all");
  const [transactions, setTransactions] = useState([]);
  const { t, i18n } = useTranslation();
  const [show, setShow] = useState(false);
  const [loader, setLoader] = useState(false);
  const [loading, setLoading] = useState(false);

  const [searchQuery, setSearchQuery] = useState("");
  const [filteredTransactions, setFilteredTransactions] = useState([]);

  const [transactionId, setTransactionId] = useState(null);
  const { lang } = useParams();

  const navigate = useNavigate(); // Initialize useNavigate

  const fetchTransactions = async () => {
    setLoading(true);
    try {
      const queryParams = {};
      if (startDate) {
        queryParams.startDate = startDate;
      }
      if (endDate) {
        queryParams.endDate = endDate;
      }

      const { data } = await apis.getAllPopup();
      if (data?.status) {
        setTransactions(data.popups);
        setFilteredTransactions(data.popups);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setShow(false);
    setTransactionId("");
    setLoader(false);
  };

  const deleteHandler = async (id) => {
    setLoader(true);
  
    try {
      const res = await apis.DeletePopup(id);
  
      if (res.status === 200) {
        toast.success(res.data.message || "Deleted successfully!");
        navigate(`/${lang || "sp"}/admin/popup-management`);
      } else {
        toast.error(res.data?.message || "Something went wrong!");
      }
  
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred.");
    } finally {
      handleClose();
      setLoader(false);
    }
  };
  
  useEffect(() => {
    (async () => {
      await fetchTransactions();
    })();
  }, []);

  const openModal = (id) => {
    setTransactionId(id);
    setShow(true);
  };

  let filteredData;
  let tables;

  filteredData =
    tab === "all"
      ? filteredTransactions
      : filteredTransactions.filter((item) => item.type == tab);

  tables = PopupTable(filteredData, {
    openModal,
  });

  const downloadTransaction = () => {
    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Selected Fields");
    XLSX.writeFile(workbook, `${tab}_investor_data.xlsx`);
  };

  useEffect(() => {
    if (searchQuery == "") {
      setFilteredTransactions(transactions);
    }
  }, [searchQuery, tab]);

  // Handle navigation to the new page on button click
  const handleCreateNewPopupClick = () => {
    const lang = i18n.language || "en"; 
    navigate(`/${lang}/admin/create-popup`);
  };


  return (
    <Box className="dashboard-main">
      <AdminNewSidebar />
      <div className="dashboard-section-main">
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            height: "100vh",
            overflow: "auto",
          }}
          className="custom-scroll"
        >
          <Header />
          {loading ? (
            <div className="loader-container">
              <div className="loader" />
            </div>
          ) : (
            <Container
              maxWidth="lg"
              sx={{ mt: 4, mb: 4 }}
              className="mainContainerComp"
            >
              <h2
                style={{
                  color: "#000",
                  fontFamily: "'Poppins', sans-serif",
                  fontSize: "36px",
                  letterSpacing: "2px",
                  textAlign: "center",
                  margin: "0 0 20px 0",
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  textShadow: "2px 2px 4px rgba(0, 0, 0, 0.3)",
                }}
              >
                {t("buttons.popup")}
              </h2>
  
              <div className="flex-with-title">
                <button
                  className="simple-btn my-2 flex-wrap btn-excel-download"
                  onClick={handleCreateNewPopupClick} // Handle the click event
                >
                  <BiPlus />
                  {t("buttons.create-new-popup")}
                  </button>
              </div>
  
              <Grid
                item
                container
                className="mt-4"
                justifyContent="center"
                sx={{ height: "600px" }}
              >
                <Box sx={{ width: "100%", marginLeft: "-10px" }}>
                  <DataGrid
                    rows={tables?.rows}
                    columns={tables?.columns}
                    getRowClassName={(params) =>
                      params.indexRelativeToCurrentPage % 2 === 0
                        ? "even"
                        : "odd"
                    }
                  />
                </Box>
              </Grid>
  
              <DeleteModal
                show={show}
                handleClose={handleClose}
                handleSubmit={deleteHandler}
                loader={loader}
                id={transactionId}
                title={t("buttons.delete-popup")}
              />
            </Container>
          )}
        </Box>
      </div>
    </Box>
  );
};

export default Popup;
